// extracted by mini-css-extract-plugin
export var active = "_b1-d";
export var blink = "_b1-e";
export var container = "_b1-5";
export var controls = "_b1-0";
export var controlsRight = "_b1-1";
export var fakeCursor = "_b1-c";
export var hidden = "_b1-b";
export var quillContainerSmall = "_b1-7";
export var quillEditor = "_b1-6";
export var quillEditorSmall = "_b1-8";
export var quillFormatButtons = "_b1-a";
export var quillToolbar = "_b1-9";
export var removePadding = "_b1-2";
export var state = "_b1-3";
export var stateTitle = "_b1-4";